import styled from 'styled-components';

export const MarginFifteen = styled.div`
  margin: 15px 15px 15px 0;
`;
